import {createBrowserHistory} from 'history'
import {useSearchParam} from "react-use";

const history = createBrowserHistory()

// Sticky query params: một số phân hệ (VD Workspace) cần giữ nguyên 1 số query param (VD
// org_id) xuyên suốt điều hướng bên trong, kể cả khi Link/NavLink/history.push ở nơi khác
// trong phân hệ không tự mang theo. Patch chung ở đây (thay vì sửa từng Link) vì mọi điều
// hướng trong app (Link, NavLink, Redirect, history.push...) đều đi qua chung 1 history này.
const STICKY_PARAMS_BY_PREFIX = [
  {prefix: '/workspace', params: ['org_id']},
]

const resolveLocation = (location) => {
  if (typeof location === 'string') {
    const [pathname, search = ''] = location.split('?')
    return {pathname, search: search ? `?${search}` : ''}
  }
  return {pathname: location?.pathname, search: location?.search ?? ''}
}

const withStickyParams = (location) => {
  const {pathname, search} = resolveLocation(location)
  const stickyParams = STICKY_PARAMS_BY_PREFIX.find(({prefix}) => pathname?.startsWith(prefix))?.params ?? []
  if (!stickyParams.length) return location

  const currentParams = new URLSearchParams(history.location?.search)
  const nextParams = new URLSearchParams(search)
  let changed = false
  stickyParams.forEach((name) => {
    if (!nextParams.has(name) && currentParams.has(name)) {
      nextParams.set(name, currentParams.get(name))
      changed = true
    }
  })
  if (!changed) return location

  return {
    ...(typeof location === 'object' ? location : {}),
    pathname,
    search: '?' + nextParams.toString(),
  }
}

const _push = history.push.bind(history)
const _replace = history.replace.bind(history)
history.push = (location, state) => _push(withStickyParams(location), state)
history.replace = (location, state) => _replace(withStickyParams(location), state)

export default history

export const useRouteSearchParam = useSearchParam

export const getRouteSearchParams = () => {
  return new URLSearchParams(window.location.search);
};
export const copyLocationParam = (location) => {
  return location ?? {}
}
export const getRoutePathParams = () => {
  return window.location.pathname;
};
export const routePathStartsWith = (location, routePathname) => {
  return location?.pathname?.startsWith(routePathname)
}

export const refreshToken = () => {
  const searchParams = getRouteSearchParams();
  searchParams.set('refresh_token', Date.now());
  history.replace({
    ...copyLocationParam(window.location ?? {}),
    pathname: window.location.pathname,
    search: '?' + searchParams.toString(),
  });
}